"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../../api/webAApi");
var UIUtils_1 = require("../../../../../../shared/modules/UIUtils");
var moment = require("moment");
var BrandsAutoWithdrawsListCtl = /** @class */ (function (_super) {
    __extends(BrandsAutoWithdrawsListCtl, _super);
    function BrandsAutoWithdrawsListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_app_currency_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_currency_id; });
        _this.dk_app_currency_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_currency_title; });
        _this.dk_is_control_withdraw_amount = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_control_withdraw_amount; });
        _this.dk_max_withdraw_amount = UIUtils_1.UIUtils.IProp2Str(function (o) { o.max_withdraw_amount; });
        _this.dk_is_control_player_level = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_control_player_level; });
        _this.dk_min_withdraw_player_level_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.min_withdraw_player_level_id; });
        _this.dk_min_withdraw_player_level_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.min_withdraw_player_level_title; });
        _this.dk_is_control_inout_percent = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_control_inout_percent; });
        _this.dk_max_inout_percent_x100 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.max_inout_percent_x100; });
        _this.dk_is_locked = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_locked; });
        _this.dk_date_added2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added2; });
        _this.dk_date_changed2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed2; });
        _this._errDialog = errDialog;
        return _this;
    }
    BrandsAutoWithdrawsListCtl.prototype.ResetData = function () {
        this.DATA = {
            total: 0,
            data: []
        };
    };
    BrandsAutoWithdrawsListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        return null;
    };
    BrandsAutoWithdrawsListCtl.prototype.LoadData = function (brandId, onDone) {
        var _this = this;
        webAApi_1.ListBrandAutoWithdrawsByBrandIdGet.exec({
            brand_id: brandId
        }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    app_currency_id: resp.list[i].app_currency_id,
                    app_currency_title: resp.list[i].app_currency_title,
                    is_control_withdraw_amount: resp.list[i].is_control_withdraw_amount,
                    max_withdraw_amount: resp.list[i].max_withdraw_amount,
                    is_control_player_level: resp.list[i].is_control_player_level,
                    min_withdraw_player_level_id: resp.list[i].min_withdraw_player_level_id,
                    min_withdraw_player_level_title: resp.list[i].min_withdraw_player_level_title,
                    is_control_inout_percent: resp.list[i].is_control_inout_percent,
                    max_inout_percent_x100: resp.list[i].max_inout_percent_x100,
                    is_locked: resp.list[i].is_locked,
                    date_added2: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed2: moment(resp.list[i].date_changed_uts_ms).utc(false),
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    BrandsAutoWithdrawsListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddBrandAutoWithdraw.exec({
            data: {
                brand_id: data.brand_id,
                app_currency_id: data.app_currency_id,
                is_control_withdraw_amount: data.is_control_withdraw_amount,
                max_withdraw_amount: data.max_withdraw_amount,
                is_control_player_level: data.is_control_player_level,
                min_withdraw_player_level_id: data.min_withdraw_player_level_id,
                is_control_inout_percent: data.is_control_inout_percent,
                max_inout_percent_x100: data.max_inout_percent_x100,
                is_locked: data.is_locked
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                app_currency_id: data.app_currency_id,
                app_currency_title: resp.app_currency_title,
                is_control_withdraw_amount: data.is_control_withdraw_amount,
                max_withdraw_amount: data.max_withdraw_amount,
                is_control_player_level: data.is_control_player_level,
                min_withdraw_player_level_id: data.min_withdraw_player_level_id,
                min_withdraw_player_level_title: resp.player_level_title,
                is_control_inout_percent: data.is_control_inout_percent,
                max_inout_percent_x100: data.max_inout_percent_x100,
                is_locked: data.is_locked,
                date_added2: moment(resp.date_added_uts_ms).utc(false),
                date_changed2: moment(resp.date_changed_uts_ms).utc(false),
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    BrandsAutoWithdrawsListCtl.prototype.EditData = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.key);
        if (_tmp) {
            webAApi_1.DoEditBrandAutoWithdraw.exec({
                data: {
                    brands_auto_withdraw_config_id: data.key,
                    is_control_withdraw_amount: data.is_control_withdraw_amount,
                    max_withdraw_amount: data.max_withdraw_amount,
                    is_control_player_level: data.is_control_player_level,
                    min_withdraw_player_level_id: data.min_withdraw_player_level_id,
                    is_control_inout_percent: data.is_control_inout_percent,
                    max_inout_percent_x100: data.max_inout_percent_x100,
                    is_locked: data.is_locked
                }
            }, function (resp) {
                _tmp.is_control_withdraw_amount = data.is_control_withdraw_amount;
                _tmp.max_withdraw_amount = data.max_withdraw_amount;
                _tmp.is_control_player_level = data.is_control_player_level;
                _tmp.min_withdraw_player_level_id = data.min_withdraw_player_level_id;
                _tmp.min_withdraw_player_level_title = resp.player_level_title;
                _tmp.is_control_inout_percent = data.is_control_inout_percent;
                _tmp.max_inout_percent_x100 = data.max_inout_percent_x100;
                _tmp.is_locked = data.is_locked;
                _tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    BrandsAutoWithdrawsListCtl.prototype.DoSetIsLocked = function (key, isLocked, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetBrandAutoWithdrawIsLocked.exec({
                data: {
                    brands_auto_withdraw_config_id: key,
                    is_locked: isLocked
                }
            }, function (resp) {
                _tmp.is_locked = isLocked;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    BrandsAutoWithdrawsListCtl.prototype.RemoveItem = function (accessKey) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === accessKey) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    BrandsAutoWithdrawsListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeleteBrandAutoWithdraw.exec({
                data: {
                    brands_auto_withdraw_config_id: key,
                }
            }, function (resp) {
                _this.RemoveItem(_tmp.key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return BrandsAutoWithdrawsListCtl;
}(BaseController_1.BaseController));
exports.BrandsAutoWithdrawsListCtl = BrandsAutoWithdrawsListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_brands_list/ctl/options/BrandsAutoWithdrawsListCtl.ts
// module id = 1043
// module chunks = 0